<template>
  <div>
    <img
      src="https://neadoo.pl/wp-content/uploads/2019/07/logo.svg"
      alt=""
      srcset=""
      class="logo-neadoo"
    />
  </div>
</template>

<script>
export default {
  name: 'Logo',
}
</script>

<style scoped>
div {
  width: 100;
}

.logo-neadoo {
  position: absolute;
  /* left: 50px; */
  /* top: 50px; */
  top: 50px;
  left: 50px;
  width: 350px;
  z-index: 3;
}
</style>
